// extracted by mini-css-extract-plugin
export default {"pagination":"_1IkjY","arrow":"X_ERn"};